import { useState } from "react";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import { EditPanDetailsModal } from "../EditPanDetailsModal/EditPanDetailsModal";
import { EditBankDetailsModal } from "../EditBankDetailsModal/EditBankDetailsModal";
import { useFetchKycStatus } from "../../services/api";
import { mapKycStatus } from "../../services/mappers/kycMapper";
import { getUserId } from "../../../../utils/auth";
import styles from "./style.module.css";


export const KYC_STATUS_UPDATED_EVENT = "mentor-kyc-status-updated";

export const AddPanAndBankDetails = () => {
  const userId = getUserId();
  const [isPanModalOpen, setIsPanModalOpen] = useState(false);
  const [isBankModalOpen, setIsBankModalOpen] = useState(false);
  const [kycStatus, setKycStatus] = useState({ hasPan: true, hasBank: true });

  const { refetch: refetchKycStatus } = useFetchKycStatus(userId, {
    onSuccess: (data) => setKycStatus(mapKycStatus(data)),
    // Fail open on error: showing the banner to a mentor who's already compliant is a minor
    // false alarm, but hiding it from one who genuinely has nothing on file silently drops
    // a compliance/payout nudge.
    onError: () => setKycStatus({ hasPan: false, hasBank: false }),
  });

  const refreshAfterSave = () => {
    refetchKycStatus();
    window.dispatchEvent(new Event(KYC_STATUS_UPDATED_EVENT));
  };

  const { hasPan, hasBank } = kycStatus;

  if (hasPan && hasBank) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.headerRow}>
        <SvgIcons name="warning_triangle" width="20" height="20" className={styles.warningIcon} />
        <span className={styles.title}>Action required</span>
      </div>

      <div className={styles.itemsList}>
        {!hasPan && (
          <div className={`${styles.infoItem} ${styles.panInfoItem}`}>
            <SvgIcons name="info_circle" width="16" height="16" className={styles.infoIcon} />
            <span className={styles.infoText}>
              Higher tax will be deducted when PAN is not provided
            </span>
          </div>
        )}
        {!hasPan && (
          <button
            className={`${styles.addButton} ${styles.panAddButton}`}
            onClick={() => setIsPanModalOpen(true)}
          >
            Add PAN details
            <SvgIcons name="add_circle_icon" width="20" height="20" />
          </button>
        )}
        {!hasBank && (
          <div className={`${styles.infoItem} ${styles.bankInfoItem}`}>
            <SvgIcons name="info_circle" width="16" height="16" className={styles.infoIcon} />
            <span className={styles.infoText}>
              Payments cannot be processed when bank details are not provided
            </span>
          </div>
        )}
        {!hasBank && (
          <button
            className={`${styles.addButton} ${styles.bankAddButton}`}
            onClick={() => setIsBankModalOpen(true)}
          >
            Add bank details
            <SvgIcons name="add_circle_icon" width="20" height="20" />
          </button>
        )}
      </div>

      <EditPanDetailsModal
        isOpen={isPanModalOpen}
        onClose={() => setIsPanModalOpen(false)}
        currentDetails={{}}
        onSaveSuccess={refreshAfterSave}
      />

      <EditBankDetailsModal
        isOpen={isBankModalOpen}
        onClose={() => setIsBankModalOpen(false)}
        currentDetails={{}}
        onSaveSuccess={refreshAfterSave}
      />
    </div>
  );
};
